<script lang="ts">
	import { _ } from 'svelte-i18n';

	export let label: string | null = null;
	export let required: boolean = true;
	export let labelAddon: string | null = null;
	export let disable: boolean = false;
</script>

<p class="font-bold {disable ? 'text-disabled' : ''} pl-2">
	{label}
	{#if labelAddon}
		<!-- svelte-ignore node_invalid_placement_ssr -->
		<p class="inline text-sm">{labelAddon}</p>
	{/if}
	{#if !required}
		<!-- svelte-ignore node_invalid_placement_ssr -->
		<p class="inline text-sm">
			{'(' + $_('general.lbl_optional') + ')'}
		</p>
	{/if}
</p>
